import React from 'react';

const VerifierProfile = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">Verifier Profile</h1>
      <p className="text-gray-600">Profile management for verifiers - Coming Soon</p>
    </div>
  );
};

export default VerifierProfile; 